import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { openWhatsApp } from '../lib/whatsapp';

const Contact = () => {
  const contactInfo = [
    {
      icon: Phone,
      title: 'Teléfono',
      content: '+54 261 655 8544',
      link: 'tel:+5492616558544'
    },
    {
      icon: Mail,
      title: 'Email',
      content: 'ventas@andesmetal.com',
      link: 'mailto:ventas@andesmetal.com'
    },
    {
      icon: MapPin,
      title: 'Ubicación',
      content: 'Mendoza, Argentina',
      link: null
    },
    {
      icon: Clock,
      title: 'Horario',
      content: 'Lun - Vie: 8:00 - 17:00',
      link: null
    }
  ];

  const handleWhatsApp = () => {
    openWhatsApp('Hola, me gustaría solicitar información sobre sus servicios.');
  };

  return (
    <section id="contacto" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-brand mb-4">
              Contáctenos
            </h2>
            <p className="text-lg text-gray-600">
              Estamos aquí para responder sus consultas y brindarle el mejor servicio
            </p>
          </div>

          {/* Contact Info Grid */}
          <div className="grid sm:grid-cols-2 gap-6 mb-12">
            {contactInfo.map((item, index) => {
              const Icon = item.icon;
              return (
                <div
                  key={index}
                  className="bg-gray-50 p-6 rounded-lg hover:shadow-md transition-shadow duration-300"
                >
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-brand rounded-lg flex items-center justify-center">
                        <Icon className="w-6 h-6 text-white" />
                      </div>
                    </div>
                    <div className="ml-4">
                      <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                        {item.title}
                      </h3>
                      {item.link ? (
                        <a
                          href={item.link}
                          className="text-lg text-brand hover:underline font-medium"
                        >
                          {item.content}
                        </a>
                      ) : (
                        <p className="text-lg text-gray-900 font-medium">{item.content}</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* CTA Card */}
          <div className="bg-gradient-to-br from-brand to-brand-dark rounded-xl p-8 sm:p-12 text-center text-white">
            <h3 className="text-2xl sm:text-3xl font-bold mb-4">
              ¿Listo para comenzar su proyecto?
            </h3>
            <p className="text-lg text-gray-200 mb-8 max-w-2xl mx-auto">
              Contáctenos hoy mismo y descubra cómo podemos ayudarlo con soluciones metalmecánicas de calidad superior
            </p>
            <button
              onClick={handleWhatsApp}
              className="inline-flex items-center px-8 py-4 bg-white text-brand font-semibold rounded-md hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              <svg
                className="w-6 h-6 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
              </svg>
              Enviar Mensaje por WhatsApp
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
